export default "__VITE_ASSET__2376ff47__"